import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';

const useStyles = makeStyles(theme => ({
  root: {
    width: '240px',
    margin: theme.spacing(1)
  },
  media: {
    height: 200
  },
  cardRoot: {
    minHeight: '400px',
    width: '100%'
  },
  stepNumber: {
    position: 'absolute',
    zIndex: 100,
    padding: '4px 12px',
    fontSize: '1.25rem',
    backgroundColor: '#fff',
    borderRadius: '4px 0'
  },
  inputRoot: {
    background: theme.palette.grey[50]
  }
}));

const Step = ({
  number,
  image,
  stepData,
  tag,
  StepContent,
  onChangeImage,
  onChangeData,
  onRemove
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root} data-testid="field-step">
      <Card classes={{ root: classes.cardRoot }}>
        <div className={classes.stepNumber}>{number}</div>
        <StepContent
          stepData={stepData}
          image={image}
          tag={tag}
          number={number}
          onChangeImage={onChangeImage}
          onChangeData={onChangeData}
          classes={classes}
        />
        <CardActions disableSpacing>
          <Tooltip title="Remove Step">
            <IconButton onClick={onRemove}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Drag step to change order">
            <DragIndicatorIcon
              style={{
                color: 'rgba(0, 0, 0, 0.54)',
                marginLeft: 'auto',
                marginRight: '8px',
                cursor: 'grab'
              }}
            />
          </Tooltip>
        </CardActions>
      </Card>
    </div>
  );
};

export default SortableElement(Step);
